export enum ENTRY_POINT {
  general,
  mePage,
  sellingPage,
  shippingPage,
  helpCentre,
  sellerCenterDesktop,
  sellerEducationHub,
  wmsLite,
  CNSellerCenterEntryPointNumber,
  CNEducationHubEntryPointNumber,
  CNEnterpriseWechatEntryPointNumber,
  mitra = 13,
  shopeeFoodHC = 14,
  cnsc = 15,
  BankHelpCenter = 19,
  BankMePage = 20,
  driver = 16,
  DriverAPPFoodOrderPage = 16,
  DriverAPPHelpCenter = 17,
  DriverAPPSPXOrderPage = 18,
  DriverAPPSPXiOrderOngoingPage = 18, // rename
  MitraPartner = 27,
  ShopeeFoodPartner = 28,
  ShopeePayPartner = 29,
  MystockPartner = 30,
  RRDetailsPage = 31,
  RRShippingPage = 32,
  DriverAPPOngoingOrderPage = 39,
  DriverAPPFoodOrderOngoingPage = 39, // rename
  DriverAPPOrderDetailsPage = 40,
  DriverAPPFoodOrderDetailsPage = 40, // rename
  DriverAPPOrderHistoryPage = 37,
  DriverAPPFoodOrderHistoryPage = 37, // rename
  DriverAPPReportIssuePage = 38,
  DriverAPPReportFoodIssuePage = 38, // rename
  DriverAPPSPXiOrderDetailsPage = 48,
  DriverAPPSPXiOrderHistoryPage = 49,
  DriverAPPReportSPXiIssuePage = 50,
  OrderDetailPage = 41,
  ShopeeAPPFoodVNHC = 42,
  ShopeeFoodVNAppHC = 43,
  ShopeeFoodVNDriverHC = 44,
  ShopeeHomePage = 47,
  ShopeeHomePageNologin = 51,
  // https://jira.shopee.io/browse/SPCSP-52799 新增
  DriverAppSPXSamedayOrderOngoingPage = 52,
  DriverAppSPXSamedayOrderDetailPage = 53,
  DriverAppSPXSamedayOrderHistoryPage = 54,
  DriverAppSPXSamedayReportIssuePage = 55,

  BankSGMePage = 45,
  BankSGHelpCenter = 46,
  BankIDMePage = 35,
  BankIDHelpCenter = 36,

  SBSOrderOngoingPage = 62,
  SBSOrderDetailsPage = 63,
  SBSOrderHistoryPage = 64,
  SBSOrderReportIssuePage = 65,
  // premium user
  mePagePremium = 100,
  helpCentrePremium = 101,
  sellingPagePremium = 102,
  shippingPagePremium = 103,
  RRDetailsPagePremium = 104,
  RRShippingPagePremium = 105,
  OrderDetailPagePremium = 141,

  ShopeeLiteGeneral = 200,
  ShopeeLiteMePage = 201,
  ShopeeLiteHelpCentre = 202,
  ShopeeLiteShippingPage = 203,
  ShopeeLiteRRDetailsPage = 204,
  ShopeeLiteRRShippingPage = 205,
}
